import { ContainerTemplateType } from '@asset/enum/problemSolvingEnum';
import { toCanvasKey } from '@asset/function/canvasKeyFunctions';
import { TeacherInformationFormField } from '@asset/enum/teacher';
export class StudyItem {
  constructor(pageMeta, problemStatusDetail, sections, container) {
    this.pageMeta = pageMeta;
    this.problemStatusDetail = problemStatusDetail;
    this.sections = sections;
    this.container = container;
  }
  existSections() {
    return this.sections !== null && this.sections.length > 0;
  }
  getCanvas(subPageIndex, canvasAreaType, canvasLayerType) {
    return this.container?.canvases?.find(canvas => canvas.layerType === canvasLayerType && canvas.key === toCanvasKey(subPageIndex, canvasAreaType));
  }
  existCanvasInView() {
    return this.existSections() ? this.sections?.some(section => section.some(obj => Array.from(CANVAS_SECTION_MEDIA_TYPES).includes(obj.mediaType))) : this.container?.templateType === ContainerTemplateType.FULL_SCREEN_CANVAS;
  }
}
export let MediaType = /*#__PURE__*/function (MediaType) {
  MediaType["IMG"] = "img";
  MediaType["TEXT"] = "text";
  MediaType["VIDEO"] = "video";
  MediaType["DRAWING_NOTE"] = "drawingNote";
  return MediaType;
}({});
export const CANVAS_SECTION_MEDIA_TYPES = new Set([MediaType.IMG, MediaType.TEXT, MediaType.DRAWING_NOTE]);
export let CanvasType = /*#__PURE__*/function (CanvasType) {
  CanvasType["IMG"] = "img";
  CanvasType["DRAWING_NOTE"] = "drawingNote";
  return CanvasType;
}({});
export let LayoutType = /*#__PURE__*/function (LayoutType) {
  LayoutType["SECTION_CONTENT"] = "sectionContent";
  LayoutType["EMPTY_CONTENT"] = "emptyContent";
  return LayoutType;
}({});
export class PageMeta {
  constructor(course, materialType, materialName, indexNameType, studyItemId, indexNumber, indexName, division, subIndexNumber) {
    this.course = course;
    this.materialType = materialType;
    this.materialName = materialName;
    this.indexNameType = indexNameType;
    this.studyItemId = studyItemId;
    this.indexNumber = indexNumber;
    this.indexName = indexName;
    this.division = division;
    this.subIndexNumber = subIndexNumber;
  }
  static from(pageDataResponse) {
    const meta = pageDataResponse.meta;
    return new PageMeta(meta.course, meta.materialType, meta.materialName, meta.indexNameType, meta.studyItemId, meta.classification.indexNumber, meta.classification.indexName, meta.classification.division, meta.classification.subIndexNumber);
  }
}